import React from "react";

const PlugIcon = ({ size = 16, className }) => {
  return (
    <span className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        viewBox="0 0 16 16"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M7 10.667h2c1.666 0 2.666-1.2 2.666-2.667V4.607c0-.7-.573-1.274-1.273-1.274h-4.78c-.7 0-1.273.574-1.273 1.274V8c-.007 1.467.993 2.667 2.66 2.667"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M6.333 1.333v2M9.667 1.333v2M8 14.667v-4"
        />
      </svg>
    </span>
  );
};

export default PlugIcon;
